import React from 'react';
import { StyledTimelineWrap } from './StyledTimelineWrap';
import TimelineTabs from '../TimelineTabs';
import TimeLineCarousel from '../TimeLineCarousel';
import { useState } from 'react';
import { useRef } from 'react';
import { useEffect } from 'react';

const TimelineWrap = ({ timelineArray }) => {
  const timelineEl = useRef(null)
  let body = document.body;
  const [shouldCount, setShouldCount] = useState(false);
  const [tabIndex, setTabIndex] = useState(0)
  const [percTimer, setPercTimer] = useState(0);
  const [isHover, setIsHover] = useState(0);
  const swiper = useRef(null);
  const globalInterval = useRef(null);
  
  function elementInViewport(el) {

    var top = el.offsetTop;
    var height = el.offsetHeight;
    
    return (
      top < (body.scrollTop + window.innerHeight) &&
      (top + height) > body.scrollTop
    );
  }
  // ** swiper handlers
  const clickSelection  = (e, i) => {
    setTabIndex(i)
    setPercTimer(0)
    swiper.current.slideTo(i)
  }
  const handleChange = () =>{
    setPercTimer(0)
    
    setTabIndex(swiper.current.realIndex)
  }
  // *

  // ** scroll handlers
  const handlerScroll = () =>{
    let isVisible = elementInViewport(timelineEl.current);
    setShouldCount(isVisible)
  }
  // ** hover handlers
  const handleHover = (isMouseHover) => {
    setShouldCount(!isMouseHover)
    setIsHover(isMouseHover)
  }
  // *

  useEffect(() => {
    
    if(percTimer >= 100) {
      clearInterval(globalInterval)
      var nextIndex = tabIndex + 1;
      nextIndex = nextIndex > (timelineArray.length - 1) ? 0 : nextIndex;

      setTabIndex(nextIndex)
      setPercTimer(0) 
      swiper.current.slideTo(nextIndex)
    }
    
  }, [percTimer])

  useEffect(() => {
    
    if(shouldCount && globalInterval.current === null && !isHover){
      
      globalInterval.current = setInterval(() => {
        setPercTimer( percTimer => percTimer + 25);
        
      }, 1000)
    }else if(isHover){
      clearInterval(globalInterval.current);
      globalInterval.current = null;
      setShouldCount(false);
    }
      
    
  },[shouldCount, isHover]);

  const handleSwiper = (el) =>{
    swiper.current = el;
  }

  useEffect(()=>{
    
    
    window.addEventListener('wheel',  handlerScroll);
    window.addEventListener('resize', handlerScroll);
    
    return () => {
      
      window.removeEventListener('wheel', handlerScroll);
      window.removeEventListener('resize', handlerScroll);
      clearInterval(globalInterval.current);
    };
  }, [])
  return (
    <React.Fragment>
      {
        <StyledTimelineWrap ref={timelineEl}>
          <h4 className="md--title">Our timeline</h4>
          <TimelineTabs active={tabIndex} handleClick={clickSelection} percTimer={percTimer} arrayYears={timelineArray}/>
          <TimeLineCarousel 
            
            arrayYears={timelineArray} 
            handleHover={handleHover}
            handleSwiper={handleSwiper}
            handleChange={handleChange}
          >

          </TimeLineCarousel>
        </StyledTimelineWrap>
          
      }
    </React.Fragment>
  );
};

export default TimelineWrap;
